// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-alert, default-case */
import Cookies from "js-cookie"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import { showModal } from "@kiwicom/frontend-common/services/modals/actions"
import { toggleOption } from "@kiwicom/frontend-common/services/options/actions"
import checkDebugEnabled from "@kiwicom/frontend-common/utils/checkDebugEnabled"

import { smartFill } from "./smartFill"

const keys = {
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  0: 48,
  1: 49,
  2: 50,
  3: 51,
  4: 52,
  5: 53,
  6: 54,
  7: 55,
  8: 56,
  9: 57,
}

function cycleLangs() {
  alert("BAMBOOZLED")
}

function displayHelpModal() {
  window.alert(
    [
      "A Change API url",
      "B Manual check_flights refresh",
      "C Switch AB version cookie",
      "D Show debug info",
      "E Enable Hidden Features",
      "F Smart fill",
      "L Switch sending logs to console <-> logstash",
      "M Switch API production <-> mock",
      "R Preferred Results View",
      "T Show Translation Keys",
      "X Switch production <-> localhost",
      "Y Cycle languages",
      "0-9 Toggle Simple AB versions",
      "---",
      "H Show help (this one)",
    ].join("\n"),
  )
}

function switchProductionLocalhost() {
  location.href =
    location.protocol === "http:"
      ? location.href.replace("http", "https").replace(location.host, "en.skypicker.com")
      : location.href.replace("https", "http").replace(location.host, "localhost:8000")
}

function fakeCuckoo() {
  const newVal = !cuckoo.fake
  Cookies.set("debug_fakeCuckoo", newVal)
  cuckoo.fake = newVal
  window.alert(`Logs will be send to: ${newVal ? "console" : "logstash"} (saved to cookies)`)
}

export default function initKeyBindings(store) {
  if (!checkDebugEnabled()) return

  document.body.addEventListener("keydown", (event) => {
    const keyCode = "which" in event ? event.which : event.keyCode
    if (event.altKey && event.ctrlKey) {
      switch (keyCode) {
        case keys.a:
          store.dispatch(showModal("debug", { activeTab: "changeAPI" }))
          break
        case keys.d:
          store.dispatch(showModal("debug", { local: event.shiftKey }))
          break
        case keys.e:
          store.dispatch(toggleOption("enableHiddenFeatures"))
          break
        case keys.f:
          smartFill()
          break
        case keys.h:
          displayHelpModal()
          break
        case keys.l:
          fakeCuckoo()
          break
        case keys.m:
          store.dispatch(showModal("debug", { activeTab: "changeAPI" }))
          break
        case keys.t:
          store.dispatch(toggleOption("showTranslationKeys"))
          break
        case keys.x:
          switchProductionLocalhost()
          break
        case keys.y:
          cycleLangs(event.shiftKey)
          break
      }
    }
  })
}

if (typeof window !== "undefined") {
  // Export for magicians
  window.magic = {
    smartFill,
  }
}
